/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmployeeExecutionBlocker } from './EmployeeExecutionBlocker';
import type { EmployeePhase_VALIDATOR } from './EmployeePhase_VALIDATOR';
export type EmployeeValidatorPhaseOutput = {
    phase: EmployeePhase_VALIDATOR;
    action: EmployeeValidatorPhaseOutput.action;
    affectedTodo: string | null;
    nextTodo: string | null;
    remainingTodosCount: number;
    objectiveCompleted: boolean;
    reason?: string;
    /**
     * Structured reason when required work is blocked.
     */
    blocker?: EmployeeExecutionBlocker;
};
export namespace EmployeeValidatorPhaseOutput {
    export enum action {
        COMPLETED_TODO = 'completed-todo',
        COMPLETED_OBJECTIVE = 'completed-objective',
        CANCELLED_TODO = 'cancelled-todo',
        CANCELLED_OBJECTIVE = 'cancelled-objective',
        BLOCKED_TODO = 'blocked-todo',
        BLOCKED_OBJECTIVE = 'blocked-objective',
        KEPT_IN_PROGRESS = 'kept-in-progress',
    }
}

